import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-password-login',
  templateUrl: './password-login.component.html',
  styleUrls: ['./password-login.component.css']
})
export class PasswordLoginComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
